// Patches Bootstrap's Modal to be null-safe after dispose().
//
// BaseComponent#dispose() nulls `_element`. If a `transitionend` callback
// scheduled before dispose() still runs `_hideModal`, it crashes:
//
//   this._element.style.display = 'none'
//   TypeError: Cannot read properties of null (reading 'style')
//
// See: TSHMANAGERWEB-HS (Sentry). Same class of Turbo + Bootstrap 5.3.x race
// as bootstrap_tooltip_safety.js.
//
// Also: allow chat dock / float composer focus while #taskModal (or any modal)
// has an active FocusTrap — chat sits above the modal (z-index 1060/1070) so
// users can type there; without this patch focus snaps back to the modal
// (emoji still worked via mousedown + execCommand).
import { Modal } from "bootstrap"
import { isChatFocusAllowed } from "./chat_focus_allowlist.js"

const originalHideModal = Modal.prototype._hideModal

Modal.prototype._hideModal = function patchedHideModal() {
  if (!this._element) {
    return
  }

  return originalHideModal.call(this)
}

const originalDispose = Modal.prototype.dispose
Modal.prototype.dispose = function patchedModalDispose() {
  try {
    return originalDispose.call(this)
  } catch (error) {
    if (error instanceof TypeError && /null|undefined/.test(String(error.message))) {
      return
    }
    throw error
  }
}

const originalInitFocusTrap = Modal.prototype._initializeFocusTrap
Modal.prototype._initializeFocusTrap = function patchedInitializeFocusTrap() {
  const trap = originalInitFocusTrap.call(this)
  const originalHandleFocusin = trap._handleFocusin.bind(trap)
  trap._handleFocusin = function patchedHandleFocusin(event) {
    if (isChatFocusAllowed(event.target)) return
    return originalHandleFocusin(event)
  }
  return trap
}
